import { createStyles, makeStyles, Theme } from '@material-ui/core'
import React, { useState } from 'react'
import {
  sanitizeFetchType,
  useListContext,
  useMutation,
  useNotify,
  useShowContext,
} from 'react-admin'
import { Authority } from '../../../core/auth/Authority'
import { ResourceName } from '../../../core/ResourceName'
import Button from '../../common/customized-mui-components/Button'
import { useHasAuthority } from '../../hooks/useHasAuthority'
import { ConfirmDialog } from '../../common/ConfirmDialog'

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    button: {
      color: theme.palette.common.white,
      margin: '2px',
    },
  }),
)

export const BookingDeactivateAllUsingsButton = () => {
  const classes = useStyles()
  const notify = useNotify()
  const hasAuthority = useHasAuthority()
  const { record: booking, loading } = useShowContext()
  const { refetch } = useListContext()
  const [confirmOpen, setConfirmOpen] = useState<boolean>(false)

  const [mutate, { loading: mutationLoading }] = useMutation()

  const handleOpenConfirm = () => {
    setConfirmOpen(true)
  }

  const handleCloseConfirm = () => {
    setConfirmOpen(false)
  }

  const onClick = async () => {
    await mutate(
      {
        type: sanitizeFetchType('deactivateAllBookingUsings'),
        resource: ResourceName.BOOKINGS,
        payload: {
          id: booking?.id,
        },
      },
      {
        returnPromise: true,
        onFailure: (err) => notify(err?.message, 'error'),
      },
    )
    handleCloseConfirm()
    refetch?.()
  }

  return (
    <>
      <ConfirmDialog
        open={confirmOpen}
        confirm={onClick}
        source="deactivateAllUsings"
        cancel={handleCloseConfirm}
        action="set"
        resource={ResourceName.BOOKINGS}
      />
      {hasAuthority(Authority.BOOKINGS_DEACTIVATE_ALL_USINGS) && (
        <Button
          disabled={loading || mutationLoading}
          className={classes.button}
          variant="contained"
          onClick={handleOpenConfirm}
          label="resources.bookings.actions.deactivateAllUsings"
          useSmallVersionBreakpoint={false}
        />
      )}
    </>
  )
}
